import React, { useContext, useEffect, useMemo, useState } from "react";
import ReactTable from "../../components/ReactTable/ReactTable.jsx";
import { config } from "../../config.js";
import { SidebarContext } from "../../context/SidebarContext";
import SectionMenuLeft from "../../components/SectionMenuLeft/SectionMenuLeft.jsx";
import "./Review.css"; //  for skeleton & polish styles
import { LuArrowLeft } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

function Review() {
	const navigate = useNavigate()
  const { isSidebar } = useContext(SidebarContext);
  const [reviews, setReviews] = useState([]);
  const [filteredReviews, setFilteredReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  //  Fetch Reviews
  const fetchReviews = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${config?.backEndBaseUrl}review`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-dashboard-request": "true",
        },
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();
      if (result.status && Array.isArray(result.reviews)) {
        setReviews(result.reviews);
        setFilteredReviews(result.reviews);
      } else {
        setReviews([]);
        setFilteredReviews([]);
      }
    } catch (error) {
      console.error("Fetching reviews failed:", error);
      setReviews([]);
      setFilteredReviews([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  //  Table Columns
  const columns = useMemo(
    () => [
      { accessorKey: "reviewText", header: "Review" },
      { accessorKey: "rating", header: "Rating" },
      {
        accessorFn: (row) => row.user?.userName || "N/A",
        header: "User Name",
      },
      {
        accessorFn: (row) => row.driver?.userName || "N/A",
        header: "Driver Name",
      },
      { accessorKey: "reviewType", header: "Review Type" },
      {
        accessorFn: (row) =>
          new Date(row.createdAt).toLocaleString("en-IN") || "N/A",
        header: "Created At",
      },
    ],
    [],
  );

  //  Skeleton Loader
  const SkeletonLoader = () => (
    <div className="skeleton-wrapper">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="skeleton-row">
          <div className="skeleton-cell long"></div>
          <div className="skeleton-cell small"></div>
          <div className="skeleton-cell medium"></div>
          <div className="skeleton-cell medium"></div>
          <div className="skeleton-cell short"></div>
          <div className="skeleton-cell small"></div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="body">
      <div id="wrapper">
        <div id="page">
          <div className="layout-wrap">
            <SectionMenuLeft />
            <div className="section-content-right">
              <div
                className="main-content"
                style={{ paddingLeft: isSidebar ? "280px" : "0px" }}
              >
                <div className="main-content-inner">
                  <div className="main-content-wrap">
                    <div className="tf-section">
                      <div className="wg-box" style={{ marginBottom: "20px" }}>
                        <div className="flex items-center justify-between mb-12 flex-wrap gap-3">
                          <div className="flex items-center gap-3">
                            <button
                              className="back-btn flex items-center gap-2"
                              onClick={() => navigate("/")}
                            >
                              <LuArrowLeft size={16} />
                              {/* <span>Back</span> */}
                            </button>

                            <h5 className="fare-heading">Reviews Overview</h5>
                          </div>
                        </div>

                        {/*  Show Skeleton or Table */}
                        {loading ? (
                          <SkeletonLoader />
                        ) : (
                          <ReactTable
                            columns={columns}
                            data={filteredReviews}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Review;
